import { render, staticRenderFns } from "./FooterTabs.vue?vue&type=template&id=a38a476a&scoped=true&"
import script from "./FooterTabs.vue?vue&type=script&lang=js&"
export * from "./FooterTabs.vue?vue&type=script&lang=js&"
import style0 from "./FooterTabs.vue?vue&type=style&index=0&id=a38a476a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38a476a",
  null
  
)

export default component.exports